import { render } from "./NotFound.vue?vue&type=template&id=0b762c3e&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=0b762c3e&scoped=true&lang=css"

import exportComponent from "D:\\hemiao100Code\\hemiao100-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b762c3e"]])

export default __exports__